import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIconProps, FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { useMemo } from 'react';

import { PurifyComponent, addVariants } from '@agilemd/ui-utils';

import styles from './styles.module.scss';

const IconComponent = PurifyComponent<FontAwesomeIconProps>(FontAwesomeIcon);
export const ICON_SIZES = [
  '1x',
  '2x',
  '3x',
  '4x',
  '5x',
  '6x',
  '7x',
  '8x',
  '9x',
  '10x',
  'xs',
  'lg',
  'sm'
] as const;
export const ICON_FLIP_TYPES = ['horizontal', 'vertical', 'both'] as const;
export const ICON_PULL_DIRECTIONS = ['left', 'right'] as const;
export const ICON_DIRECTIONS = [90, 180, 270] as const;

export interface IconProps extends Omit<FontAwesomeIconProps, 'icon' | 'mask' | 'ref'> {
  icon: string[] | { iconName: string; prefix: string };
  mask?: string[] | { iconName: string; prefix: string };
  fixedWidth?: boolean;
}

const Icon = ({
  className,
  fixedWidth = true,
  icon,
  mask,
  ...props
}: IconProps): React.JSX.Element => {
  const newClassName = useMemo(
    () => classnames(className, addVariants('aglmd-icon', styles, fixedWidth && 'fw')),
    [className, fixedWidth]
  );
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const typedIcon: IconProp = icon as any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const typedMask: IconProp = mask as any;

  return (
    <IconComponent
      className={newClassName}
      fixedWidth={fixedWidth}
      icon={typedIcon}
      mask={typedMask}
      {...props}
    />
  );
};

export default Icon;
